
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import Beleg from '@/types/Beleg';
    import {mapMutations, mapState} from 'vuex';

    @Component({
        computed: {
            ...mapState('patient', ['loaders']),
        }
    })

    export default class Stornierung extends Vue {
        @Prop() visible!: boolean;
        @Prop() value!: Beleg;

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                //this.value.anmerkung = 'Beleg ' + this.value.jahr + ' | ' + this.value.belegnr + ' stornieren.';
                this.value.anmerkung = '';
            }
        }

        public clickOnStornieren() {
            this.$emit('confirmed');
            this.$emit('close');
        }
    }
